import { useState } from 'react';
import cn from 'classnames';
import { PersonCard } from 'pages/AboutUs/Management/PersonCard';
import styles from 'pages/AboutUs/Management/tabs/Tabs.scss';

export const Committees = ({ data: management }) => {
  const [openPersonId, setOpenPersonId] = useState(null);

  if (!management?.length) return null;

  const nonPresidiumMembers = management.filter(({ subdivision }) => subdivision !== 'Presidium');

  const committeeGroups = nonPresidiumMembers.reduce((groups, person) => {
    const { subdivision } = person;
    if (!groups[subdivision]) {
      groups[subdivision] = [];
    }
    groups[subdivision].push(person);
    return groups;
  }, {});

  const handleToggle = (id) => setOpenPersonId((prevId) => (prevId === id ? null : id));

  return Object.entries(committeeGroups).map(([committeeName, committeeMembers], index) => (
    <section className={cn({ [styles.section]: index !== 0 })} key={committeeName}>
      <div className={styles.title}>{committeeName}</div>
      <div className={styles.membersList}>
        {committeeMembers.map((person) => (
          <PersonCard
            person={person}
            isOpen={openPersonId === person.id}
            onToggle={() => handleToggle(person.id)}
            key={person.id}
          />
        ))}
      </div>
    </section>
  ));
};
